import { ILauncher } from './launcher.interface';
import { WindowsManagerService } from "../../../services/os/windows-manager.service";
import { DynamicAppLoaderService } from '../../dynamic-app-loader.service';
import { IFile } from 'src/app/interfaces/io/file.interface';
import { ILaunchSettings } from 'src/app/interfaces/io/launch-settings.interface';
import { PathHelper } from 'src/app/helpers/path.helper';

export class LocalAppLauncher implements ILauncher {
  private static loadedApps = {};
  private static registeredApps = {};
  private static formatAssotiations = {};

  constructor(
    private windowsMgr: WindowsManagerService,
    private dynamicAppLoader: DynamicAppLoaderService) {
  }

  static async registerApp(protocol: string, module: any, assotiations?: string[]) {
    LocalAppLauncher.registeredApps[protocol] = module;

    if (assotiations) {
      assotiations.forEach(k => LocalAppLauncher.formatAssotiations[k] = protocol);
    }
  }

  async launchByFormat(file: IFile, content: string, settings?: ILaunchSettings): Promise<number> {
    let appUrl = LocalAppLauncher.formatAssotiations[PathHelper.getExtension(file.path)];

    if (!appUrl) {
      appUrl = LocalAppLauncher.formatAssotiations["*"];
    }

    // const finalSettings: ILaunchSettings = settings || { args: [] };

    /** @todo Maybe the content should not be readed previously */
    // finalSettings.args.push("--content");
    // finalSettings.args.push(content);

    return this.launch(file, appUrl, settings);
  }

  async launch(file: IFile, url: string, settings?: ILaunchSettings): Promise<number> {
    const module = LocalAppLauncher.loadedApps[url] || LocalAppLauncher.registeredApps[url];
    if (!module) {
      throw new Error("Module not found.");
    }

    const componentFactory = await this.dynamicAppLoader.loadComponentFactoryFromModule(module);
    if (!componentFactory) {
      throw new Error("The module could not be loaded.");
    }

    const window = this.windowsMgr.createWindow(file.getName(), file.icon);
    window.overflow = true;

    const finalSettings: ILaunchSettings = settings || { args: [] };
    const absPath = PathHelper.getAbsolutePath(file.path, finalSettings.cwd);
    finalSettings.args.unshift(absPath);

    window.content = {
      component: componentFactory,
      data: finalSettings
    };

    this.windowsMgr.addWindow(window);

    return window.id;
  }
}
